import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import AvatarInfo from './AvatarInfo';

const Holder = styled.div`
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${props => props.theme.colours.lightGrey2};
`;

class AvatarInfoHolder extends Component {

  render() {
    if( this.props.showInfo ) {
      return (
        <Holder>
          {this.props.children}
          <AvatarInfo details={this.props.details}/>
        </Holder>
      )
    } else {
      return (<>{this.props.children}</>);
    }
  }
}

AvatarInfoHolder.propTypes = {
  showInfo: PropTypes.bool.isRequired,
  details: PropTypes.object.isRequired,
};

AvatarInfoHolder.defaultProps = {
  showInfo: false,
};

export default AvatarInfoHolder;
